export default __webpack_public_path__ + "static/media/ShipOther.111a0660.png";